/* BG COM motion runtime: snippets/bgcom-motion.liquid (rendered once, end of <body>, after bgcom-baseline-site).
   No library. Exposes window.BGM; sections queue work with (window.BGMq = window.BGMq || []).push(fn).
   Rules: content is visible by default; an element is hidden only once the IntersectionObserver has answered for it and
   it is then below the screen; html.bgm-on is set at the observer's first answer, and if none comes within 2.5 s of
   DOMContentLoaded the layer gives up and everything stays shown. Reveals fire 15% of the screen BEFORE the element enters,
   anything already more than 60% on screen (anchor jump, fast scroll) or passed above is shown at once, one-shot, never
   replayed; 400ms or less per element, follower 80ms, siblings 60ms. A price or a buying control is never hidden.
   prefers-reduced-motion = no hiding, no movement. */
(function(){
  'use strict';
  if(window.BGM) return;
  var d = document, root = d.documentElement;
  var mqR = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mqF = window.matchMedia('(hover: hover) and (pointer: fine)');
  var hasIO = 'IntersectionObserver' in window;
  var canA = typeof Element !== 'undefined' && typeof Element.prototype.animate === 'function';
  /* the system (tokens of the style block): two curves, three durations */
  var OUT = 'cubic-bezier(.2,.7,.2,1)', SPRING = 'cubic-bezier(.34,1.56,.64,1)';
  var DUR = { fast:200, base:400, slow:7000 };
  function snap(ms){ return +ms >= 400 ? DUR.base : DUR.fast; }   /* any requested duration lands on a token: under 400ms = fast */
  /* linear() easing: older engines (Safari/iOS before 17.2, Chrome before 113...) THROW on it in Element.animate().
     The system no longer uses any, but a raw linear() string passed to BGM.ease() / BGM.animate() still comes back as the
     out-curve there. BGM.ease.out / .spring are the two curves; the legacy names (back, springB1, springB2, words) map
     onto the out-curve. */
  var LIN = false;
  try{ LIN = !!(window.CSS && CSS.supports && CSS.supports('transition-timing-function', 'linear(0, 1)')); }catch(_){}
  var EASE = { out:OUT, spring:SPRING, back:OUT, springB1:OUT, springB2:OUT, words:OUT };
  function ease(n){
    if(EASE.hasOwnProperty(n)) return EASE[n];
    return (!LIN && typeof n === 'string' && n.indexOf('linear(') > -1) ? OUT : n;
  }
  Object.keys(EASE).forEach(function(k){ ease[k] = EASE[k]; });
  /* Element.animate that never throws: an easing the engine rejects is retried with the out-curve, then given up (null) */
  function ani(el, frames, opts){
    if(!canA || !el) return null;
    var op = opts;
    if(opts && typeof opts === 'object'){ op = {}; for(var k in opts) op[k] = opts[k]; if(op.easing) op.easing = ease(op.easing); }
    try{ return el.animate(frames, op); }
    catch(_){
      try{ if(op && typeof op === 'object') op.easing = OUT; return el.animate(frames, op); }catch(__){ return null; }
    }
  }
  var ALT = false;   /* content: "x" / "" (generated text with an empty alt text) */
  try{ ALT = !!(window.CSS && CSS.supports && CSS.supports('content', '"a" / ""')); }catch(_){}

  function reduced(){ return mqR.matches; }
  function ready(fn){ if(d.readyState === 'loading') d.addEventListener('DOMContentLoaded', fn, { once:true }); else fn(); }
  function all(t){
    if(!t) return [];
    if(typeof t === 'string'){ try{ return [].slice.call(d.querySelectorAll(t)); }catch(_){ return []; } }
    if(t.nodeType === 1) return [t];
    return [].slice.call(t);
  }
  function vh(){ return window.innerHeight || root.clientHeight; }
  function flush(el){ try{ void window.getComputedStyle(el).opacity; }catch(_){} }
  /* below the fold: its top is under the viewport right now (never hide what is on screen or already passed) */
  function below(el){ return el.getClientRects().length > 0 && el.getBoundingClientRect().top >= vh(); }

  /* ── reveal on scroll ──
     BGM.reveal(target, preset, { items, stagger, delay, prepare, also:[{ items, preset, delay, stagger }] })
     presets: up · rise · card · spring · fan = rise 16px (12px under 768px) + fade; words = the whole heading rises 12px and
     its text fades in (no word split, no blur); fade = opacity only; blur = image fade + settle from scale 1.02 (no filter);
     pop = fade + scale .96; badge = fade + scale .6 on the spring (small element).
     One trigger per host: every item of a host (and of its `also` groups) plays together, so a group never shows one side
     blank. delay is capped at 160ms (follower), stagger at 90ms, any start at 600ms; each element lasts 700ms (owner's rule,
     30/09). 'fan' staggers by index. threshold, rootMargin, replay, words and atoms are accepted and ignored: every reveal
     fires when the top reaches 80% of the screen. */
  /* owner's rule (30/09): fire when the element's top reaches 80% of the screen (it is visibly entering), 700ms each,
     follower 160ms, siblings 90ms apart, no start later than 600ms. Scrolled past fast (already more than 60% on screen or
     above it) = shown at once. */
  var RM = '0px 0px -20% 0px', LINE = .8, SEEN = .6, FOLLOW = 160, STEP = 90, MAXOFF = 600, REV = 700;
  var KEEP = '.bgb-side,.bgb-panel,.bgb-panel__cta,.bgs-btn,.product-form__submit,.product-card__atc,[data-bgm-keep]';
  var VARS = ['--bgm-delay', '--bgm-dur', '--bgm-fx', '--bgm-fy', '--bgm-fr'];
  var on = !mqR.matches && hasIO;
  /* reload, back/forward or #anchor: the browser restores the scroll after this runs, so never hide anything */
  var restored = (function(){
    if(location.hash && location.hash.length > 1) return true;
    try{ var n = performance.getEntriesByType('navigation')[0]; return !!n && (n.type === 'reload' || n.type === 'back_forward'); }catch(_){ return false; }
  })();
  if(restored || (window.Shopify && window.Shopify.designMode)) on = false;
  /* arriving late (more than 2.5s after the page was ready: slow network, blocked then released script): never hide anything */
  try{ var nav0 = performance.getEntriesByType('navigation')[0]; if(nav0 && nav0.domContentLoadedEventEnd > 0 && performance.now() - nav0.domContentLoadedEventEnd > 2500) on = false; }catch(_){}
  var waiting = new Set(), IO = null, alive = false, dead = false, dog = 0, armT = 0;

  /* a buying control or the pack price panel is never hidden, nor anything that contains one */
  function keep(el){ try{ return el.matches(KEEP) || !!el.querySelector(KEEP); }catch(_){ return false; } }
  function setS(st, s){ st.s = s; st.els.forEach(function(el){ el.setAttribute('data-bgm-s', s); }); }
  function unobs(h){ if(IO) try{ IO.unobserve(h); }catch(_){} }
  function finish(h){  /* hands the element back to its component: attributes and inline variables go, values are already final */
    var st = h._bgm; if(!st) return;
    h._bgm = null; clearTimeout(st.t); waiting.delete(h);
    st.els.forEach(function(el){
      el.removeAttribute('data-bgm-s'); el.removeAttribute('data-bgm');
      VARS.forEach(function(v){ el.style.removeProperty(v); });
    });
  }
  function play(h){    /* animated reveal from the hidden state */
    var st = h._bgm; if(!st || st.s === 'in' || st.s === 'i') return;
    waiting.delete(h); unobs(h);
    if(st.s !== 'w'){ setS(st, 'w'); st.els.forEach(flush); }
    setS(st, 'in');
    st.t = setTimeout(function(){ finish(h); }, st.total);
  }
  function show(h){    /* shown at once, no transition (passed, already on screen, focus, print, give-up) */
    var st = h._bgm; if(!st || st.s === 'i') return;
    clearTimeout(st.t); waiting.delete(h); unobs(h);
    setS(st, 'i'); st.els.forEach(flush);
    st.t = setTimeout(function(){ finish(h); }, 50);
  }
  function showAll(){ waiting.forEach(function(h){ show(h); }); }
  function onIO(list){
    if(dead || !on) return;
    if(!alive){ alive = true; clearTimeout(armT); armT = 0; root.classList.add('bgm-on'); }
    var H = vh();
    /* live geometry: inside the theme's content-visibility:auto block the entry's own rect is empty (0,0) while the
       subtree is skipped, which would read as "on screen".
       04/10/2026 (speed r2): every rect is read first, then the states are written (one layout per callback, not one per entry) */
    var rs = list.map(function(e){ var st = e.target._bgm; return (!st || st.s === 'in' || st.s === 'i') ? null : e.target.getBoundingClientRect(); });
    list.forEach(function(e, i){
      var h = e.target, st = h._bgm, r = rs[i];
      if(!r || !st || st.s === 'in' || st.s === 'i') return;
      if(st.s === 'p'){                                  /* first answer for this host: arm it */
        if(r.top >= H){ setS(st, 'w'); if(e.isIntersecting){ st.els.forEach(flush); play(h); } }
        else show(h);                                    /* already on screen or passed: it was never hidden */
        return;
      }
      if(!e.isIntersecting){ if(r.bottom <= 0) show(h); return; }
      var vis = Math.min(r.bottom, H) - Math.max(r.top, 0);
      if(r.top < 0 || vis > SEEN * Math.max(1, Math.min(r.height, H))) show(h); else play(h);
    });
  }
  function io(){ return IO || (IO = new IntersectionObserver(onIO, { threshold:0, rootMargin:RM })); }
  function giveUp(){   /* the observer never answered: the layer stands down, everything stays shown */
    if(alive || dead) return;
    dead = true; on = false; armT = 0;
    root.classList.remove('bgm-on');
    showAll();
    if(IO) try{ IO.disconnect(); }catch(_){}
  }
  function deadline(){ if(!alive && !dead && !armT && d.visibilityState !== 'hidden') armT = setTimeout(giveUp, 2500); }
  function atEnd(){ var se = d.scrollingElement || root; return (window.scrollY || se.scrollTop) + vh() >= se.scrollHeight - 4; }
  function watch(){    /* 1 s watchdog: a waiting element already past the trigger line (or passed above) is shown at once;
                          one sitting in the bottom fifth waits for its line, unless the page cannot scroll further (then it plays) */
    var H = vh(), end = atEnd(), acts = [];
    /* 04/10/2026 (speed r2): read every waiting rect first, then show / play (one layout per tick) */
    waiting.forEach(function(h){
      if(!h.isConnected){ acts.push([h, 0]); return; }
      var st = h._bgm; if(!st || st.s !== 'w') return;
      var r = h.getBoundingClientRect();
      if(r.bottom <= 0 || r.top < H * LINE) acts.push([h, 1]);
      else if(end && r.top < H) acts.push([h, 2]);
    });
    acts.forEach(function(a){ if(a[1] === 0) finish(a[0]); else if(a[1] === 1) show(a[0]); else play(a[0]); });
    if(!waiting.size){ clearInterval(dog); dog = 0; }
  }
  function arm(){
    if(!dog) dog = setInterval(watch, 1000);
    deadline();
  }
  d.addEventListener('visibilitychange', function(){ if(waiting.size) deadline(); });
  d.addEventListener('focusin', function(e){ waiting.forEach(function(h){ if(h.contains(e.target)) show(h); }); });
  window.addEventListener('beforeprint', showAll);
  window.addEventListener('hashchange', showAll);
  d.addEventListener('touchstart', function(){}, { passive:true });   /* iOS only shows :active (press states) when a touch listener exists */
  /* 04/10/2026 (speed r3): the reveal() calls made in the same task (the queued sections at load: about ten on a product page) are
     handled together at the end of that task (microtask): ONE geometry read pass for all of them, then the writes, in call order.
     Before, each call read the geometry after the previous call had written its 'p' marks: one forced layout per call during the
     motion.js task (66 ms on the aerosol, 4x CPU). Same result: the marks an earlier call is about to write are tracked in two sets
     (hosts, elements), so a later call skips exactly what it skipped before; 'p' has no visual effect, so the geometry is the same. */
  var revQ = [], revT = 0;
  function reveal(target, preset, o){
    o = o || {};
    ready(function(){
      if(!on) return;
      revQ.push([target, preset, o]);
      if(!revT){ revT = 1; Promise.resolve().then(revFlush); }
    });
  }
  function revFlush(){
    revT = 0;
    var jobs = revQ; revQ = [];
    if(!on || !jobs.length) return;
    var H = vh(), vH = new Set(), vE = new Set(), todo = [], any = false;
    function hasM(el){ return el.hasAttribute('data-bgm') || vE.has(el); }
    function inM(el){ for(var n = el; n && n.nodeType === 1; n = n.parentElement){ if(hasM(n)) return true; } return false; }
    jobs.forEach(function(job){
      var preset = job[1], o = job[2], mine = [];
      /* 1) reads: where each block is, and its items' prepare (geometry); a block or an item already marked (for real, or by an
         earlier call of this batch) is skipped, as when the calls ran one after the other */
      all(job[0]).forEach(function(host){
        if(host.hasAttribute('data-bgm-h') || vH.has(host) || inM(host) || keep(host)) return;
        if(!(host.getClientRects().length > 0 && host.getBoundingClientRect().top >= H)) return;
        var groups = [{ items: o.items, preset: preset, delay: o.delay, stagger: o.stagger, prepare: o.prepare }].concat(o.also || []);
        var marks = [];
        groups.forEach(function(g){
          var pre = g.preset || preset;
          var els = (g.items ? [].slice.call(host.querySelectorAll(g.items)) : [host]).filter(function(el){ return !hasM(el) && !keep(el); });
          var base = Math.min(Math.max(+g.delay || 0, 0), FOLLOW);
          var step = pre === 'fan' ? STEP : Math.min(Math.max(+g.stagger || 0, 0), STEP);
          els.forEach(function(el, i){
            var off = base + i * step;
            if(g.prepare){
              var r = null;
              try{ r = g.prepare(el, i, els, host); }catch(_){}
              if(typeof r === 'number' && r >= 0 && pre !== 'fan') off = base + r;
            }
            off = Math.min(off, MAXOFF);
            marks.push([el, pre, off, REV]);
          });
        });
        if(marks.length) mine.push([host, marks]);
      });
      /* what this call writes (same checks as its write pass), recorded for the later calls of the batch */
      mine.forEach(function(t){
        var host = t[0];
        if(vH.has(host) || host.hasAttribute('data-bgm-h') || inM(host)) return;
        var marks = t[1].filter(function(m){ return !hasM(m[0]); });
        if(!marks.length) return;
        marks.forEach(function(m){ vE.add(m[0]); });
        vH.add(host);
        todo.push([host, marks]);
      });
    });
    /* 2) writes, in call order: the 'p' marks (no visual effect), then the observer */
    todo.forEach(function(t){
      var host = t[0], marks = t[1], end = 0;
      marks.forEach(function(m){ if(m[2] + m[3] > end) end = m[2] + m[3]; });
      marks.forEach(function(m){
        m[0].setAttribute('data-bgm', m[1]);
        m[0].setAttribute('data-bgm-s', 'p');
        m[0].style.setProperty('--bgm-delay', m[2] + 'ms');
        m[0].style.setProperty('--bgm-dur', m[3] + 'ms');
      });
      host.setAttribute('data-bgm-h', '');
      host._bgm = { els: marks.map(function(m){ return m[0]; }), total: end + 60, s: 'p', t: 0 };
      waiting.add(host); io().observe(host); any = true;
    });
    if(any) arm();
  }

  /* ── text roll (runhappy): the label sits in a clip; copy A (the label's own text node, in a span) and copy B
     (.bgm-roll::after, content attr(data-bgm-t) with an empty alt text). The DOM keeps ONE copy of the label, so link
     text, SEO anchor text, analytics link_text, find-in-page and screen readers are unchanged. Built only where it can
     play: a fine hovering pointer (touch never gets it: no DOM change on phones), motion allowed, and an engine that knows
     the alt-text syntax. The roll always goes upward: in on enter, on again on leave (B out above, A back from below);
     a leave or re-enter during a roll waits for it to land, so it never reverses. ── */
  var rollQ = [];
  function rollOK(){ return ALT && mqF.matches && !mqR.matches; }
  function rollMs(host){
    var a = host.querySelector('.bgm-roll__a'); if(!a) return 0;
    var t = 0; try{ t = parseFloat(window.getComputedStyle(a).transitionDuration) || 0; }catch(_){}
    return Math.round(t * 1000);
  }
  function rollFlush(host){
    var w = host.querySelector('.bgm-roll'), a = host.querySelector('.bgm-roll__a');
    try{ if(a) void window.getComputedStyle(a).translate; if(w) void window.getComputedStyle(w, '::after').translate; }catch(_){}
  }
  function rollStep(host){
    var R = host._bgmR; if(!R || R.busy) return;
    var cl = host.classList, ms = rollMs(host) + 40;
    function landed(){ R.busy = 0; rollStep(host); }
    if(R.want && R.st === 'rest'){
      cl.add('is-rh'); R.st = 'hover';
      R.busy = setTimeout(landed, ms);
    } else if(!R.want && R.st === 'hover'){
      cl.add('is-rp'); cl.remove('is-rh'); rollFlush(host);
      cl.add('is-ro'); cl.remove('is-rp'); R.st = 'rest';
      R.busy = setTimeout(function(){
        cl.add('is-rq'); cl.remove('is-ro'); rollFlush(host); cl.remove('is-rq');
        landed();
      }, ms);
    }
  }
  function rollWire(host){
    if(host._bgmR) return;
    var R = host._bgmR = { st: 'rest', want: false, busy: 0 };
    host.addEventListener('pointerenter', function(e){ if(e.pointerType === 'touch') return; R.want = true; rollStep(host); });
    host.addEventListener('pointerleave', function(e){ if(e.pointerType === 'touch') return; R.want = false; rollStep(host); });
  }
  function rollNow(target, o){
    all(target).forEach(function(host){
      if(host.querySelector('.bgm-roll')) return;
      var el = o.inner ? host.querySelector(o.inner) : host; if(!el) return;
      var tn = [].filter.call(el.childNodes, function(n){ return n.nodeType === 3 && n.nodeValue.trim(); })[0];
      if(!tn) return;
      var raw = tn.nodeValue, txt = raw.trim(), at = raw.indexOf(txt);
      var w = d.createElement('span'), a = d.createElement('span');
      w.className = 'bgm-roll'; a.className = 'bgm-roll__a';
      w.setAttribute('data-bgm-t', txt);
      a.textContent = txt; w.appendChild(a);
      var frag = d.createDocumentFragment();
      if(at > 0) frag.appendChild(d.createTextNode(raw.slice(0, at)));
      frag.appendChild(w);
      if(at + txt.length < raw.length) frag.appendChild(d.createTextNode(raw.slice(at + txt.length)));
      el.replaceChild(frag, tn);
      host.classList.add('bgm-roll-host');
      rollWire(host);
    });
  }
  function rollAll(){ if(rollOK()) rollQ.forEach(function(q){ rollNow(q[0], q[1]); }); }
  function roll(target, o){
    o = o || {};
    rollQ.push([target, o]);
    ready(function(){ if(rollOK()) rollNow(target, o); });
  }

  /* ── gliding highlight (dropship Flip pill): one soft shape per group, FLIP-moved between items ──
     BGM.glide(hostSelector, itemSelector, { px, py, radius, color, over }), mouse + fine pointer only (CSS hides it
     elsewhere, a touch clears it). Movement: 200ms on the out-curve (a dur of 400 or more snaps to 400; ease is always
     the out-curve). over (default: auto, when the items are already positioned with z-index auto): the pill becomes opaque
     (its tint blended on the background behind the group) and sits above the rows' hairlines; the items and their
     sibling content are lifted above it (z-index 1), so the hairline never shows through while it glides. ── */
  var glides = [], pillHosts = [];
  function glide(h, i, o){ glides.push({ h:h, i:i, o:o || {} }); }
  function matchItem(t){
    if(!t || t.nodeType !== 1) return null;
    for(var k = 0; k < glides.length; k++){
      var g = glides[k], it = t.closest(g.i), host = it && it.closest(g.h);
      if(host) return { g:g, host:host, it:it };
    }
    return null;
  }
  function matchHost(t){
    if(!t || t.nodeType !== 1) return null;
    for(var k = 0; k < glides.length; k++){ var host = t.closest(glides[k].h); if(host) return host; }
    return null;
  }
  function rgba(c){
    var m = /rgba?\(\s*([\d.]+)[\s,]+([\d.]+)[\s,]+([\d.]+)(?:[\s,\/]+([\d.]+%?))?/.exec(c || '');
    if(!m) return null;
    var a = m[4] == null ? 1 : (m[4].slice(-1) === '%' ? parseFloat(m[4]) / 100 : +m[4]);
    return [+m[1], +m[2], +m[3], a];
  }
  function solid(color, host){   /* the tint blended on the first opaque background behind the group */
    var c = rgba(color); if(!c) return color;
    var bg = [255, 255, 255], n = host;
    while(n && n.nodeType === 1){
      var b = rgba(window.getComputedStyle(n).backgroundColor);
      if(b && b[3] > .99){ bg = b; break; }
      n = n.parentElement;
    }
    return 'rgb(' + [0, 1, 2].map(function(k){ return Math.round(c[k] * c[3] + bg[k] * (1 - c[3])); }).join(',') + ')';
  }
  function lift(x){
    var cs = window.getComputedStyle(x);
    if(cs.zIndex !== 'auto' && cs.position !== 'static') return;
    x.classList.add('bgm-glide-it');
    if(cs.position === 'static') x.classList.add('bgm-glide-rel');
  }
  function setup(g, host, el, it){
    var o = g.o, cs = window.getComputedStyle(it);
    var over = o.over != null ? !!o.over : (cs.position !== 'static' && cs.zIndex === 'auto');
    if(!over) return;
    host.classList.add('bgm-glide-host--over');
    [].forEach.call(host.querySelectorAll(g.i), function(item){
      lift(item);
      var p = item.parentElement;
      if(p && p !== host) [].forEach.call(p.children, function(s){ if(s !== item && s !== el) lift(s); });
    });
    el.style.backgroundColor = solid(o.color || window.getComputedStyle(el).backgroundColor, host);
  }
  function place(g, host, it){
    if(host._bgmCur === it) return;
    var o = g.o, el = host._bgmGlide;
    if(!el || el.parentNode !== host){
      el = d.createElement('span'); el.className = 'bgm-glide'; el.setAttribute('aria-hidden', 'true');
      host.classList.add('bgm-glide-host'); host.appendChild(el); host._bgmGlide = el;
      if(pillHosts.indexOf(host) < 0) pillHosts.push(host);
      if(o.radius != null) el.style.borderRadius = o.radius + 'px';
      if(o.color) el.style.backgroundColor = o.color;
      try{ setup(g, host, el, it); }catch(_){}
    }
    var px = o.px != null ? o.px : 0, py = o.py != null ? o.py : 0;
    var hr = host.getBoundingClientRect(), r = it.getBoundingClientRect();
    var from = (host._bgmCur && el.classList.contains('is-on')) ? el.getBoundingClientRect() : null;
    el.style.width = (r.width + px * 2) + 'px';
    el.style.height = (r.height + py * 2) + 'px';
    el.style.translate = (r.left - hr.left - host.clientLeft - px) + 'px ' + (r.top - hr.top - host.clientTop - py) + 'px';
    host._bgmCur = it;
    el.classList.add('is-on');
    if(from && canA && !mqR.matches){
      var to = el.getBoundingClientRect();
      if(to.width && to.height) ani(el, [
        { transform: 'translate(' + (from.left - to.left) + 'px,' + (from.top - to.top) + 'px) scale(' + (from.width / to.width) + ',' + (from.height / to.height) + ')' },
        { transform: 'none' }
      ], { duration: snap(o.dur), easing: OUT });
    }
  }
  function leave(host){ host._bgmCur = null; if(host._bgmGlide) host._bgmGlide.classList.remove('is-on'); }
  d.addEventListener('pointerover', function(e){
    if(e.pointerType !== 'mouse' || !glides.length || !mqF.matches) return;
    var m = matchItem(e.target); if(m) place(m.g, m.host, m.it);
  }, { passive:true });
  d.addEventListener('pointerout', function(e){
    if(e.pointerType !== 'mouse' || !glides.length) return;
    var host = matchHost(e.target); if(!host) return;
    var to = e.relatedTarget;
    if(to && to.nodeType === 1 && host.contains(to)) return;   /* still inside the group: the pill stays put */
    leave(host);
  }, { passive:true });
  d.addEventListener('pointerdown', function(e){ if(e.pointerType !== 'mouse') pillHosts.forEach(leave); }, { passive:true });   /* a tap never leaves a pill behind */

  /* ── swapText: live texts (CTA label, count, franco line) change at once, no caption animation (jury D6) ── */
  function swapText(el, text){
    if(!el) return;
    text = String(text);
    if(el.textContent !== text) el.textContent = text;
  }

  /* ── amount swap (was the odometer): the DOM always holds the whole new formatted amount (never a partial number); it
     comes in from 8px below while the old amount (a generated copy with an empty alt text) leaves 8px upward, 200ms on
     the out-curve. BGM.odometer(el, text, { fade:true }) = crossfade only (TTC line). A new value during a swap lands the
     running one first. Reduced motion, a blank previous value or an engine without the alt-text syntax for the old copy:
     the new amount is written at once (the latter still gets the short entrance). ── */
  function endAmt(el){
    var s = el._bgmAmt; if(!s) return;
    el._bgmAmt = null; clearTimeout(s.t);
    el.classList.remove('bgm-amt', 'bgm-amt--fade');
    el.removeAttribute('data-bgm-old');
    if(el.textContent !== s.text) return;
    el.textContent = s.text;   /* unwrap: plain text node again */
  }
  function odometer(el, text, o){
    if(!el) return;
    text = String(text); o = o || {};
    var prev = el.getAttribute('data-bgm-val');
    if(prev == null) prev = el.textContent;
    if(el._bgmAmt){ endAmt(el); try{ void window.getComputedStyle(el, '::after').opacity; }catch(_){} }
    el.setAttribute('data-bgm-val', text);
    if(prev === text){ if(el.textContent !== text) el.textContent = text; return; }
    if(mqR.matches || !el.isConnected || !String(prev).replace(/ /g, ' ').trim()){ el.textContent = text; return; }
    var n = d.createElement('span');
    n.className = 'bgm-amt__n'; n.textContent = text;
    el.textContent = ''; el.appendChild(n);
    if(o.fade || o.mode === 'fade') el.classList.add('bgm-amt--fade');
    if(ALT) el.setAttribute('data-bgm-old', prev);
    el.classList.add('bgm-amt');
    el._bgmAmt = { text: text, t: setTimeout(function(){ endAmt(el); }, DUR.fast + 60) };
  }

  /* ── pop (badge pop): the spring, on a small element only ── */
  function pop(el, o){
    if(!el || !canA || mqR.matches) return null;
    o = o || {};
    return ani(el, [{ scale: String(o.from == null ? .6 : o.from), opacity: 0 }, { scale: '1', opacity: 1 }], { duration: snap(o.dur), easing: SPRING });
  }

  /* ── spark (the pro pill's one-shot sparkle, snippets/bgcom-pro-price): tiny 4-point stars (the Fly success-modal
     polygon) leave the origin (o.x, o.y inside host; default its centre), 40ms apart, each 400ms on the out-curve
     (scale .2 to 1, a quarter turn) then a 200ms fade; every node is removed at the end. host must be positioned.
     o.sparks = [[dx, dy, size, colour], ...] (px). Reduced motion: nothing (the CSS hides them too). ── */
  var SPK = [[-6, -10, 6, 'var(--bgm-i1)'], [4, -12, 5, 'var(--bgm-i2)'], [-7, 10, 5, 'var(--bgm-i3)'], [7, 12, 6, 'var(--bgm-i4)']];
  function spark(host, o){
    if(!host || !host.isConnected || mqR.matches) return false;
    o = o || {};
    var list = o.sparks || SPK, frag = d.createDocumentFragment(), made = [];
    list.forEach(function(p, i){
      var s = d.createElement('i');
      s.className = 'bgm-spark'; s.setAttribute('aria-hidden', 'true');
      s.style.cssText = '--ox:' + (o.x || '50%') + ';--oy:' + (o.y || '50%') + ';--x:' + p[0] + 'px;--y:' + p[1] + 'px;--s:' + p[2] + 'px;--c:' + p[3] + ';--d:' + (i * 40) + 'ms';
      frag.appendChild(s); made.push(s);
    });
    host.appendChild(frag);
    setTimeout(function(){ made.forEach(function(s){ if(s.parentNode) s.parentNode.removeChild(s); }); }, (list.length - 1) * 40 + DUR.base + DUR.fast + 60);
    return true;
  }

  /* ── site-wide wiring (header, footer, cart badge) ── */
  function site(){
    roll('.header__menu .menu__item', { inner: '.btn-text' });
    roll('.footer-custom .footer-menu-link');
    roll('.footer-custom .footer-legal-links a');
    /* cart badge: pop only when the count goes UP; the observer sits on the cart link so it survives the badge being replaced */
    if('MutationObserver' in window) all('.header-section a.cart-drawer-button').forEach(function(a){
      function badge(){ return a.querySelector('cart-count'); }
      function count(){ var c = badge(); return c ? (parseInt(c.textContent, 10) || 0) : 0; }
      var last = count();
      new MutationObserver(function(){
        var now = count(), c = badge();
        if(now > last && c && !c.hidden) pop(c, { from:.5, dur:200 });
        last = now;
      }).observe(a, { childList:true, characterData:true, subtree:true });
    });
  }

  /* ── ambient loops run only near the screen (pack ring + glow, stock sonar): CSS pauses them under .bgm-off ── */
  var gateIO = null;
  function gate(target){
    if(!hasIO) return;
    ready(function(){
      if(!gateIO) gateIO = new IntersectionObserver(function(list){
        list.forEach(function(e){ e.target.classList.toggle('bgm-off', !e.isIntersecting); });
      }, { rootMargin: '200px 0px' });
      all(target).forEach(function(el){ gateIO.observe(el); });
    });
  }

  /* public API. ease: BGM.ease.out / .spring (legacy .back / .springB1 / .springB2 / .words = out-curve), or BGM.ease('out');
     animate: Element.animate that never throws (or null); amount = odometer; keep = the never-hidden selector; dur = the
     three durations in ms. */
  var BGM = window.BGM = { reveal:reveal, roll:roll, glide:glide, swapText:swapText, odometer:odometer, amount:odometer, pop:pop, spark:spark, gate:gate,
    reduced:reduced, ready:ready, ease:ease, animate:ani, linear:LIN, keep:KEEP, dur:DUR };
  var queued = window.BGMq;
  window.BGMq = { push: function(fn){ try{ fn(BGM); }catch(err){ if(window.console) console.warn('[bgm]', err); } } };
  if(queued && queued.length) [].slice.call(queued).forEach(function(fn){ window.BGMq.push(fn); });
  ready(site);
  function onMq(mq, fn){ if(mq.addEventListener) mq.addEventListener('change', fn); else if(mq.addListener) mq.addListener(fn); }
  onMq(mqR, function(e){ if(e.matches){ on = false; showAll(); root.classList.remove('bgm-on'); } else rollAll(); });
  onMq(mqF, rollAll);   /* a mouse or trackpad appears (hybrid tablet): the rolls are built then, never torn down */
})();
